import './CountriesList.scss';
// @vendor
import React from 'react';
import PropTypes from 'prop-types';
// @utilities
const { formatText } = require('core/i18n').i18n;
// @components
import CountryListItem from './CountryListItem';
import filterNames from './filterNames';
import { sortContinentNames, sortCountryNames } from './sortNames';
import ZoneListItem from './ZoneListItem';
import OriginCountryListItem from './OriginCountryListItem';
// @assets
import noResultsImg from 'assets/images/no-results.png';

const countResultsCountries = (data, filterStr) => (
    data
        .flatMap(zone => zone.countries)
        .filter(country => filterNames(country, filterStr))
        .length
);


const countResultsZones = (data, filterStr) => (
    data
        .filter(zone => filterNames(zone, filterStr))
        .length
);


const CountriesList = ({ data, filter: filterStr, onCountryClick, onZoneClick, onZoneSelect,
zoneSelected, originCountryZone, onClickOriginCountryZone, conceal, originCountry }) => (
    <div className="countries-list">
        {
            !filterStr &&
            <ul className="nav nav-stacked">
                <li>
                    <OriginCountryListItem
                        nameLiteral={originCountryZone.nameLiteral}
                        isEnabled={originCountryZone.enabled}
                        onClickOriginCountryZone={onClickOriginCountryZone}
                        originCountry={originCountry}
                        disabled={conceal}
                    />
                </li>
                {
                    data
                    .sort(sortContinentNames)
                    .map(zone => (
                        <li key={zone.code}>
                            <ZoneListItem
                                data={zone.countries}
                                code={zone.code}
                                name={zone.nameLiteral}
                                open={zoneSelected === zone.code}
                                onClick={onZoneClick}
                                onCountryClick={onCountryClick}
                                onSelect={onZoneSelect}
                                originCountry={originCountry}
                                disabled={conceal}
                            />
                        </li>
                    ))
                }
            </ul>
        }
        {
            filterStr &&
            countResultsZones(data, filterStr) > 0 &&
            <div>
                <h4 className="tit-continent">
                    {formatText('cardsConfig-zones')}
                </h4>
                <ul className="nav nav-stacked">
                    {
                        data
                        .filter(zone => filterNames(zone, filterStr))
                        .sort((countryA, countryB) => sortCountryNames(countryA, countryB, originCountry))
                        .map(zone => (
                            <li key={zone.code}>
                                <ZoneListItem
                                    data={zone.countries}
                                    code={zone.code}
                                    name={zone.nameLiteral}
                                    open={zoneSelected === zone.code}
                                    onClick={onZoneClick}
                                    onCountryClick={onCountryClick}
                                    onSelect={onZoneSelect}
                                    disabled={conceal}
                                />
                            </li>
                        ))
                    }
                </ul>
            </div>
        }
        {
            filterStr &&
            countResultsCountries(data, filterStr) > 0 &&
            <div>
                <h4 className="tit-countries">
                    {formatText('cardsConfig-countries')}
                </h4>
                <ul className="nav nav-stacked">
                    {
                        data
                        .flatMap(zone => zone.countries)
                        .filter(country => filterNames(country, filterStr))
                        .sort((countryA, countryB) => sortCountryNames(countryA, countryB, originCountry))
                        .map(country => (
                            <li key={country.name}>
                                <CountryListItem
                                    active={country.enabled}
                                    code={country.name}
                                    name={country.nameLiteral}
                                    onClick={onCountryClick}
                                    disabled={conceal}
                                />
                            </li>
                        ))
                    }
                </ul>
            </div>
        }
        {
            filterStr &&
            countResultsZones(data, filterStr) == 0 &&
            countResultsCountries(data, filterStr) == 0 &&
            <div className="container-noresults">
                <img
                    src={noResultsImg}
                    alt={formatText('cardsConfig-noResults')}
                />
                <p>
                    {formatText('cardsConfig-noResults')}
                </p>
            </div>
        }
    </div>

);


CountriesList.defaultProps = {
    filter: '',
};

CountriesList.propTypes = {
    data: PropTypes.array.isRequired,
    filter: PropTypes.string,
    onCountryClick: PropTypes.func,
    onZoneClick: PropTypes.func,
    onZoneSelect: PropTypes.func,
    originCountry: PropTypes.string.isRequired,
    zoneSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    originCountryZone: PropTypes.object,
    onClickOriginCountryZone: PropTypes.func,
    conceal: PropTypes.bool
};


export default CountriesList;
